import { render } from "./WhatsAppConnectionsStatistics.vue?vue&type=template&id=46c3962e&scoped=true"
import script from "./WhatsAppConnectionsStatistics.vue?vue&type=script&lang=js"
export * from "./WhatsAppConnectionsStatistics.vue?vue&type=script&lang=js"

import "./WhatsAppConnectionsStatistics.vue?vue&type=style&index=0&id=46c3962e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c3962e"]])

export default __exports__